export default __webpack_public_path__ + "static/media/ncell_logo.7d896b7c.svg";